module.exports = __webpack_public_path__ + "media/svg/au-5b393cb4.svg";